import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
} from "@mui/material";
import PaperDraggable from "../../../../../components/PaperDraggable";
import {FormProvider, useForm} from "react-hook-form";
import {useMutation, useQueryClient} from "react-query";
import axiosClient from "../../../../../lib/axios";
import {enqueueSnackbar} from "notistack";
import StepperIncluirAgrotoxico from "./Stepper";
import {
    ICriarAgrotoxico,
    IDetalharAgrotoxico
} from "../../../../../types/api/receituarioAgronomico/detalhar-agrotoxico";
import DialogAppBar from "../../../../../components/DialogAppBar";

export default function DialogIncluirAgrotoxico({
                                                    open,
                                                    handleClose,
                                                }: DialogIncluirAgrotoxicoProps) {
    const queryClient = useQueryClient();

    // Mutation for creating agrotoxico
    const {mutate: cadastrarAgrotoxico} = useMutation({
        mutationKey: "cadastrar-agrotoxico",
        mutationFn: (inputs: ICriarAgrotoxico) =>
            axiosClient.post("/receituario-agronomico/agrotoxicos/adicionar-agrotoxico", inputs),
        onError: () => {
            enqueueSnackbar("Erro ao cadastrar agrotóxico!", {variant: "error"});
        },
        onSuccess: () => {
            queryClient.invalidateQueries("listar-todos-agrotoxicos");
            handleClose();
            enqueueSnackbar("Agrotóxico cadastrado com sucesso!", {
                variant: "success",
            });
        },
    });


    // Handlers for step navigation
    const handleNextStep = () => {
        const stepper = getValues("stepper");
        setValue("stepper", stepper + 1);
    };

    const handleBackStep = () => {
        const stepper = getValues("stepper");
        setValue("stepper", stepper - 1);
    };

    const onSubmit = (data: any) => {
        cadastrarAgrotoxico({
            ingrediente_ativo_id: data.step01.ingredientes.id,
            marca_comercial: data.step01.marca_comercial,
            titular_registro: data.step01.titular_registro,
            classe: data.step01.classe,
            modo_acao: data.step01.modo_acao,
            classe_toxicologica: data.step01.classe_toxicologica,
            classe_ambiental: data.step01.classe_ambiental,
            organico: data.step01.organico,
            empresa_pais_tipo: data.step01.empresa_pais_tipo,
            cultura_praga_relacionamento: data.step02.relacionamentos,
        });
    };

    // Form default values
    const defaultValuesForm = {
        stepper: 0,
        step01: {
            marca_comercial: "",
            titular_registro: "",
            ingredientes: null,
            classe: "",
            modo_acao: "",
            classe_toxicologica: "",
            classe_ambiental: "",
            organico: "",
            empresa_pais_tipo: "",
        },
        step02: {
            relacionamentos: [
                { cultura: null, pragas: [] },
            ]
        },
        funcoesAux: {
            onNext: handleNextStep,
            onBack: handleBackStep,
            onCloseModal: handleClose,
            onSubmit: onSubmit
        },
    };
    const methods = useForm({defaultValues: defaultValuesForm});
    const {getValues, setValue} = methods;

    return (
        <FormProvider {...methods}>
            <Dialog
                open={open}
                fullWidth
                PaperComponent={PaperDraggable}
                aria-labelledby="draggable-dialog-title"
                maxWidth={"md"}
                scroll="body"
            >
                <DialogTitle sx={{ cursor: "move" }} id="draggable-dialog-title">
                    Incluir Agrotóxico
                </DialogTitle>
                <StepperIncluirAgrotoxico/>

                <DialogActions>
                    <Button variant="text" onClick={handleClose}>
                        Fechar
                    </Button>
                </DialogActions>
            </Dialog>
        </FormProvider>
    );
}

interface DialogIncluirAgrotoxicoProps {
    open: boolean;
    handleClose: () => void;
    defaultValue?: IDetalharAgrotoxico | null;
}